import React from 'react';
import ChartDashboard from '../components/ChartDashboard';

export default function ChartsPage() {
  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: '4px' }}>Charts</h1>
      <p style={{ color: '#7B8399', fontSize: '0.8rem', marginBottom: '24px' }}>Historische Kursdaten — 2 Aktien, 2 Indizes, 2 Anleihen</p>
      <ChartDashboard />
    </div>
  );
}
